<template>
    <div>
                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>

        <modal :show.sync="modals.modal16">
                <template slot="header">
                   <span style="font-size: 24px; color: black;" v-if="language =='ltr'" >Confirmation</span>
                   <span style="font-size: 24px; color: black;text-align:right;" v-else >تأكيد</span>
                </template>
                <div>

                <p style="font-family: 'Open Sans', sans-serif, Helvetica" v-if="language=='ltr'">Are you sure you want to archive the assignment ?</p>
                <p style="font-family: 'Open Sans', sans-serif, Helvetica; text-align:right;" v-else >هل أنت متأكد أنك تريد أرشفة المهمة؟</p>

                </div>
                <template slot="footer">

                    <base-button type="secondary" @click="modals.modal16 = false" v-if="language=='ltr'">Cancel</base-button>
                    <base-button type="secondary" @click="modals.modal16 = false" v-else >إلغاء</base-button>
                   <base-button type="secondary" @click="archiveAssignmentFunction()" v-if="language=='ltr'">Confirm</base-button>
                   <base-button type="secondary" @click="archiveAssignmentFunction()" v-else >نعم</base-button>

                </template>
               </modal>

               <modal :show.sync="modals.modal17">
                       <template slot="header">
                          <span style="font-size: 24px; color: black;" v-if="language =='ltr'" >Confirmation</span>
                          <span style="font-size: 24px; color: black;text-align:right;" v-else >تأكيد</span>
                       </template>
                       <div>

                       <p style="font-family: 'Open Sans', sans-serif, Helvetica" v-if="language=='ltr'">Are you sure you want to delete the assignment ?</p>
                       <p style="font-family: 'Open Sans', sans-serif, Helvetica; text-align:right;" v-else >هل أنت متأكد أنك تريد حذف المهمة؟</p>

                       </div>
                       <template slot="footer">

                           <base-button type="secondary" @click="modals.modal17 = false" v-if="language=='ltr'">Cancel</base-button>
                           <base-button type="secondary" @click="modals.modal17 = false" v-else >إلغاء</base-button>
                          <base-button type="secondary" @click="deleteAssignmentFunction()" v-if="language=='ltr'">Confirm</base-button>
                          <base-button type="secondary" @click="deleteAssignmentFunction()" v-else >نعم</base-button>

                       </template>
                      </modal>

        <div class="container-fluid mt--7" :dir="language">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                          <base-button class="btn-primary btn-sm" style="margin-top:-20px;" v-on:click="back">{{texts.back}}</base-button>
                            <h3 v-if ="textleft" class="mb-0">{{texts.editassignment}}</h3>
                            <h3 v-else style="text-align : right;"class="mb-0">{{texts.editassignment}}</h3>
                        </div>
                        <div class="card-body">
                           <form v-on:submit.prevent="onSubmit(title, message, );">
                            <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-6" >
                                <h3 v-if="textleft">Enter Title</h3>
                                <h3 v-else style="text-align:right;">أدخل العنوان</h3>

                                <base-input v-if="textleft" alternative placeholder="Title" v-model="title" ></base-input>
                                <base-input v-else alternative placeholder="العنوان" v-model="title" ></base-input>
                              </div>
                            </div>
                          </fieldset>
                          <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-6">
                                <h3 v-if="textleft">Enter Description</h3>
                                <h3 v-else style="text-align:right;">أدخل الوصف</h3>
                                <form>
                                  <input v-if="textleft" style="text-transform: capitalize;" v-model="message" class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Description..."></input>
                                  <input v-else style="text-transform: capitalize;" v-model="message" class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="الوصف... "></input>
                                  <!-- <p class="float-md-right">Characters left : {{160 - message.length}}</p> -->
                                </form>
                              </div>
                            </div>
                          </fieldset>
                            <!-- <br> -->
                            <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-4">
                               <h3 v-if="textleft">AIGC Team Members</h3>
                               <h3 v-else style="text-align :right;">أعضاء الفريق</h3>

                              <div class="row">
                                <div class="col-md-6" v-for="(fieldName, pos1) in teammembers">
                             <base-checkbox  class="mb-3"  :key="pos1" v-model="teammembers[pos1].checked">
                                    {{fieldName.name}}
                                </base-checkbox>
                                </div>
                                </div>
                               <!--  <base-checkbox class="mb-3" >
                                    Ahmad Barakat
                                </base-checkbox>
                                <base-checkbox class="mb-3" >
                                    Attayeb Zahran
                                </base-checkbox>
                                <base-checkbox class="mb-3" >
                                    Nasser Barakat
                                </base-checkbox> -->

                              </div>
                            </div>
                          </fieldset>
                          <h3 v-if="textleft">Client Representatives</h3>
                          <h3 v-else style="text-align : right;">ممثلو العميل</h3>
<!--                           <fieldset class="form-group">
                            <div class="row">
                              <div class="col-3">
                                <base-input alternative placeholder="Name"  ></base-input>
                              </div>
                              <div class="col-5">
                                <base-input alternative placeholder="Email"  ></base-input>
                              </div>
                              <div class="col-1">
                                <base-button class="btn" type="success" v-on:click="onAddComitteeMember">Add</base-button>
                              </div>
                            </div>
                          </fieldset> -->
                          <fieldset class="form-group" v-for="(fieldName, pos) in committeeMembers" :key="pos">
                             <div class="row">
                              <div class="col-3">
                                <base-input v-if="textleft" alternative placeholder="Name" v-model="committeeMembers[pos].name" ></base-input>
                                <base-input v-else alternative placeholder="الاسم" v-model="committeeMembers[pos].name" ></base-input>
                              </div>
                              <div class="col-5">
                                <base-input v-if="textleft" alternative placeholder="Email" v-model="committeeMembers[pos].email"  ></base-input>
                                <base-input v-else alternative placeholder="البريد الإلكتروني" v-model="committeeMembers[pos].email"  ></base-input>
                              </div>
                              <div class="col-1">
                                <base-button v-if="textleft"class="btn btn-sm" type="success" v-on:click="onAddComitteeMember">Add</base-button>
                                <base-button v-else class="btn btn-sm" type="success" v-on:click="onAddComitteeMember">إضافة</base-button>
                              </div>
                              <div class="col-1" v-if="pos > 0">
                                <base-button v-if="textleft" class="btn btn-sm" type="danger" v-on:click="onRemoveCommitteeMember(pos)">Remove</base-button>
                                <base-button v-else class="btn btn-sm" type="danger" v-on:click="onRemoveCommitteeMember(pos)">إزالة</base-button>
                              </div>
                            </div>
                          </fieldset>
                                  <h3 v-if="textleft">Entities</h3>
                                  <h3 v-else style="text-align : right;">وحدات العمل</h3>
                                <div  v-for="(fieldName, pos1) in entities" :key="pos1">
                                  <!-- <br>
                                  <br>
                                  <br> -->
                                  <div class="row">
                                  <div class="col-3">
                                    <base-input v-if="textleft" alternative placeholder="Name" v-model="entities[pos1].entity"></base-input>
                                    <base-input v-else alternative placeholder="الاسم" v-model="entities[pos1].entity"></base-input>
                                  </div>
                                  <div class="col-1" align="right" style="margin-bottom: 10px">
                                      <base-button v-if="textleft" class="btn btn-sm" type="success" v-on:click="onAddEntity">Add Entity</base-button>
                                      <base-button v-else class="btn btn-sm" type="success" v-on:click="onAddEntity">إضافة وحدة عمل</base-button>

                                    </div>
                                    <div class="col-1" align="right" style="margin-bottom: 10px">
                                       <base-button class="btn btn-sm" type="danger" v-if="textleft && pos1 > 0" v-on:click="onRemoveEntity(pos1)">Remove Entity</base-button>
                                       <base-button class="btn btn-sm" type="danger" v-if="!textleft && pos1 > 0" v-on:click="onRemoveEntity(pos1)">إزالة وحدة عمل</base-button>
                                    </div>
                                    </div>
                                    <!-- </div> -->
                                  <!--  v-bind:style="[pos2 > 0 ? {'margin-left' : '235px'} : {'margin-left' : '235px'/*,'margin-top' : '-88px'*/}]"-->
                                  <div class="row"  v-for="(fieldName, pos2) in entities[pos1].phases" :key="pos2">
                                  <div class="col-2" >
                                    <base-input  v-if="textleft" alternative placeholder="Phase" v-model="entities[pos1].phases[pos2].name"></base-input>
                                    <base-input  v-else alternative placeholder="مرحلة" v-model="entities[pos1].phases[pos2].name"></base-input>
                                  </div>
                                  <div class="col-2" style="margin-top: -29px;"  >
                                    <h4 v-if="pos2 == 0 && pos1 == 0 && textleft">Start Date</h4>
                                    <h4 v-else-if="pos2 == 0 && pos1 == 0 && !textleft" style="text-align : right;">تاريخ البدء</h4>
                                    <h4 v-else style="color: #00000000;">.</h4>
                                     <base-input >
                                    <flat-picker id="startDate" slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 :config="{allowInput: true}"
                                                 class="form-control datepicker"
                                                 v-model="entities[pos1].phases[pos2].start_date" style="font-size: 12px;height: 43px;"
                                                 @on-change="onChange(pos1,pos2,0)">
                                    </flat-picker>
                                </base-input>
                                  </div>
                                  <div class="col-2" style="margin-top: -29px;" >
                                    <h4 v-if="pos2 == 0 && pos1 == 0 && textleft">End Date</h4>
                                    <h4 v-else-if="pos2 == 0 && pos1 == 0 && !textleft" style="text-align : right;">تاريخ الانتهاء</h4>
                                    <h4 v-else style="color: #00000000;">.</h4>
                                     <base-input >
                                    <flat-picker id="endDate" slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 :config="{allowInput: true}"
                                                 class="form-control datepicker"
                                                 @on-change="onChange(pos1,pos2,1)"
                                                 v-model="entities[pos1].phases[pos2].end_date" style="font-size: 12px;height: 43px;">
                                    </flat-picker>
                                </base-input>
                                  </div>
                                  <div class="col-3">
                                    <base-dropdown>
                                        <base-button id="reportType" slot="title" type="secondary" @change="onChangeRType($event, pos1, pos2)" class="dropdown-toggle" v-model="entities[pos1].phases[pos2].findings_type">
                                          {{displayFindingsType(entities[pos1].phases[pos2].findings_type)}}
                                        </base-button>
                                        <span class="dropdown-item" value="Internal Audit" v-on:click="onChangeRType($event, pos1, pos2)">{{texts.internal_audit}}</span>
                                        <span class="dropdown-item" value="Risk Assessment" v-on:click="onChangeRType($event, pos1, pos2)">{{texts.riskassessment}}</span>
                                        <span class="dropdown-item" value="Forensic" v-on:click="onChangeRType($event, pos1, pos2)">{{texts.forensic}}</span>
                                        <span class="dropdown-item" value="Compliance Audit" v-on:click="onChangeRType($event, pos1, pos2)">{{texts.compliance_audit}}</span>
                                        <span class="dropdown-item" value="Remedial Actions" v-on:click="onChangeRType($event, pos1, pos2)">{{texts.remedial_actions}}</span>
                                        <span class="dropdown-item" value="Other" v-on:click="onChangeRType($event, pos1, pos2)">{{texts.other}}</span>
                                      </base-dropdown>
                                  </div>
                                  <div class="col-1">
                                    <base-button v-if="textleft" class="btn btn-sm" type="success" v-on:click="onAddPhase(pos1, pos2)" >Add</base-button>
                                    <base-button v-else class="btn btn-sm" type="success" v-on:click="onAddPhase(pos1, pos2)" >إضافة</base-button>
                                  </div>
                                  <div class="col-1">
                                    <base-button  class="btn btn-sm" type="danger" v-if="textleft && pos2 > 0" v-on:click="onRemovePhase(pos1, pos2)">Remove</base-button>
                                    <base-button class="btn btn-sm" type="danger" v-if="!textleft && pos2 > 0" v-on:click="onRemovePhase(pos1, pos2)">إزالة</base-button>
                                  </div>

                                </div>
                                <!-- <div class="col-1" align="right" style="margin-bottom: 10px">
                                    <base-button class="btn btn-sm" type="success" v-on:click="onAddEntity" >Add Entity</base-button>

                                  </div>
                                  <div class="col-1" align="right" style="margin-bottom: 10px">
                                     <base-button class="btn btn-sm" type="danger" v-if="pos1 > 0" v-on:click="onRemoveEntity(pos1)">Remove Entity</base-button>
                                  </div> -->
                                </div>

                            <fieldset class="form-group">
                            <div class="row">
                              <div v-if="textleft" class="col-md-6">
                                 <base-button  type="primary" v-on:click="onSubmit">Save</base-button>
                                 <!-- <base-button v-else type="primary" v-on:click="onSubmit" style="text-align : right;">إنشاء مهمة</base-button> -->
                              </div>
                              <div v-else class="col-md-6 text-right">
                                 <!-- <base-button  type="primary" v-on:click="onSubmit">Create Assignment</base-button> -->
                                 <base-button  type="primary" v-on:click="onSubmit" style="text-align : right;">{{texts.editassignment}}</base-button>
                              </div>
                            </div>

                            <div class="row">
                              <div v-if="textleft" class="col-md-2">
                                 <base-button  type="warning" v-on:click="archiveAssignment">{{texts.archive}}</base-button>
                                 <!-- <base-button v-else type="primary" v-on:click="onSubmit" style="text-align : right;">إنشاء مهمة</base-button> -->
                              </div>
                              <div v-else class="col-md-2 text-right">
                                 <!-- <base-button  type="primary" v-on:click="onSubmit">Create Assignment</base-button> -->
                                 <base-button  type="warning" v-on:click="archiveAssignment" style="text-align : right;">{{texts.archive}}</base-button>
                              </div>
                              <div v-if="textleft" class="col-md-2">
                                 <base-button  type="danger" v-on:click="deleteAssignment">{{texts.delete}}</base-button>
                                 <!-- <base-button v-else type="primary" v-on:click="onSubmit" style="text-align : right;">إنشاء مهمة</base-button> -->
                              </div>
                              <div v-else class="col-md-2 text-right">
                                 <!-- <base-button  type="primary" v-on:click="onSubmit">Create Assignment</base-button> -->
                                 <base-button  type="danger" v-on:click="deleteAssignment" style="text-align : right;">{{texts.delete}}</base-button>
                              </div>
                            </div>
                          </fieldset>
                          </form>
<!--                                 <div class="col-lg-3 col-md-6"
                                     v-for="(icon, index) in icons" :key="icon.name + index">
                                    <button type="button"
                                            v-b-tooltip.hover.top
                                            :title="icon.name"
                                            v-clipboard:copy="icon.name"
                                            v-clipboard:success="onCopy"
                                            class="btn-icon-clipboard" data-clipboard-text="air-baloon">
                                        <div>
                                            <i :class="icon.name"></i>
                                            <span>{{icon.name.substring(6)}}</span>
                                        </div>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>






    </div>

</template>
<script>
  import { mapState } from "vuex";
  import { GET_TEAM_MEMBERS, EDIT_ASSIGNMENT, GET_ASSIGNMENT_DETAILS, ARCHIVE_ASSIGNMENT, DELETE_ASSIGNMENT } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { mapGetters } from "vuex";
  import UserService from "@/common/user.service";
  Vue.use(VueClipboard)

  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker},
    data() {
      return {
        texts : {
          back : UserService.getLanguage() === "rtl" ? "رجوع" : "Back",
          editassignment : UserService.getLanguage() === "rtl" ? "تحديث المهام" : "Edit Assignment",
          archive : UserService.getLanguage() === "rtl" ? "أرشفة" : "Archive",
          internal_audit : UserService.getLanguage() === "ltr" ? "Internal Audit" : "التدقيق الداخلي",
          riskassessment : UserService.getLanguage() === "ltr" ? "Risk Assessment" : "تقييم المخاطر",
          forensic : UserService.getLanguage() === "ltr" ? "Forensic" : "تحقيقات الاحتيال",
          compliance_audit : UserService.getLanguage() === "ltr" ? "Compliance Audit" : "تدقيق مدى الالتزام",
          remedial_actions : UserService.getLanguage() === "ltr" ? "Remedial Actions" : "إجراءات تصحيحية",
          other : UserService.getLanguage() === "ltr" ? "Other" : "أخرى",
          delete : UserService.getLanguage() === "ltr" ? "Delete" : "حذف"

        },
        language : UserService.getLanguage() || "ltr",
        textleft : UserService.getLanguage() === "ltr" ? true : false,
        title : '',
        budget : '',
        timeslot : '8:00-10:00',
        teammembers : store.getters.teamMembers,
        message : '',
        budget : '',
        modals : {
          modal16 : false,
          modal17 : false
        },
        tiers : {
          all : true,
          starter : false,
          silver : false,
          gold : false,
          platinum : false
        },
        dates: {
          simple: new Date().toISOString().split(" ")[0]
        },
        committeeMembers : [
          {
            name : "",
            email : ""
          }
        ],
        entities : [
          {entity : "",
            phases : [
            {name : "", start_date : new Date().toISOString().split(" ")[0].split("T")[0], end_date : new Date().toISOString().split(" ")[0].split("T")[0], actual_start_date : "-", actual_end_date : "-", findings_type : UserService.getLanguage() === "ltr" ? "Type": "النوع"}
              ]
          }
        ],
        index : 0,
        is_initial_modification : false
      }
    },
      computed: {
        ...mapGetters(["isAuthenticated", "teamMembers"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
    mounted() {
      Promise.all([
        store.dispatch(GET_ASSIGNMENT_DETAILS, UserService.getAssignmentId())
      ]).then((data) => {
        console.log(data[0]['data']);
        console.log('ASSIGNMENT DETAILS');
        console.log(data[0]);

          this.loaded = true;

          if (data[0]['errFlag'] == 0) {
            this.is_initial_modification = true;
            this.teammembers = data[0]['data']['team_members'];
            this.committeeMembers = data[0]['data']['committee_members'];
            this.title = data[0]['data']['title'];
            this.message = data[0]['data']['description'];
            this.entities = data[0]['data']['entities'];
            for (let y = 0; y < this.entities.length; y++) {

            }
            // this.is_initial_modification = false;
          }

          // console.log(store.getters.teamMembers);
          // this.teammembers = data[0]['data'];

          // this.teammembers = teamMembers;
          // console.log(this.stores);
          // console.log(this.visitsdata);
          // this.initBigChart(this.stores[0]);
          // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });
    },


    methods: {
      displayFindingsType(finding_type) {
        console.log("HELLO");
        if (this.language === 'rtl') {
          if (finding_type === "Internal Audit") {
            return this.texts.internal_audit;
          }
          else if (finding_type === "Risk Assessment") {
            return this.texts.riskassessment;
          }
          else if (finding_type === "Compliance Audit") {
            return this.texts.compliance_audit;
          }
          else if (finding_type === "Forensic") {
            return this.texts.forensic;
          }
          else if (finding_type === "Other") {
            return this.texts.other;
          }
          else if (finding_type === "Remedial Actions") {
            return this.texts.remedial_actions;
          }
          else {
            return finding_type;
          }
        }
        else {
          return finding_type;
        }
      },
      back() {
        window.history.back();
        // this.$router.push({ name: 'sendsms' });
      },
      onAddPhase(pos, pos2) {
        console.log(this.entities[0].phases[0].start_date);
        // this.entities[pos].phases.push({name : "", start_date : new Date().toISOString().split(" ")[0], end_date : new Date().toISOString().split(" ")[0], actual_start_date : "-", actual_end_date : "-", findings_type :  this.textleft ? "Type": "النوع"});
        this.entities[pos].phases.splice( pos2+1, 0, {name : "", start_date : new Date().toISOString().split(" ")[0], end_date : new Date().toISOString().split(" ")[0], actual_start_date : "-", actual_end_date : "-", findings_type :  this.textleft ? "Type": "النوع", "is_new" : 1});
      },
      onRemovePhase(pos, phasepos) {
        console.log(this.entities[pos]);
        console.log(this.entities[pos].phases)
        this.entities[pos].phases.splice(phasepos,1);
      },
      onAddEntity() {
        this.entities.push({entity : "",
            phases : [
            {name : "", start_date : new Date().toISOString().split(" ")[0], end_date : new Date().toISOString().split(" ")[0],             "actual_start_date" : "-",
            "actual_end_date" : "-", findings_type :  this.textleft ? "Type": "النوع"}
              ]
          });
      },
      onRemoveEntity(pos) {
        this.entities.splice(pos,1);
      },
      onAddComitteeMember() {
        console.log(this.committeeMembers);
        this.committeeMembers.push({"name" : "", "email" : ""});
      },
      onRemoveCommitteeMember(pos) {
        console.log(this.committeeMembers);
        this.committeeMembers.splice(pos,1);
      },
      checkIfDateErrors() {
        let dateErrors = false;
        console.log(this.entities);
        console.log(this.entities.length);
        for (let i = 0; i < this.entities.length; i++) {
          // console.log("FOR LOOP 1");
          console.log(this.entities[i].phases);
          console.log(this.entities[i].phases.length);
           for (let j = 0; j < this.entities[i].phases.length; j++) {
            // console.log("FOR LOOP 2");
            if (this.entities[i].phases[j]) {
            // console.log(this.entities[i].phases[j]);
            // console.log(this.entities[i].phases[j]['start_date']);
            // this.entities[i].phases[j]['start_date'] = new Date(this.entities[i].phases[j]['start_date']).toISOString().split(" ")[0];
            // this.entities[i].phases[j]['end_date'] = new Date(this.entities[i].phases[j]['end_date']).toISOString().split(" ")[0];
            let start = new Date(this.entities[i].phases[j]['start_date']);
            let current = new Date();

            console.log(start.getMonth(), current.getMonth() ,start.getDate(), current.getDate());
            // console.log("PART 1 : " + (start.getMonth() !== current.getMonth() ||   start.getDate() !== current.getDate()));
            // console.log("PART 2 : " + (new Date(this.entities[i].phases[j]['start_date']) < new Date()));
              console.log(new Date(this.entities[i].phases[j]['start_date']) < new Date() && (start.getMonth() !== current.getMonth() ||   start.getDate() !== current.getDate()));
            // console.log("INDEX : "+ i,j);
            // console.log("PHASE : " + this.entities[i].phases[j]);
            // if (new Date(this.entities[i].phases[j]['start_date']) < new Date() && (start.getMonth() !== current.getMonth() ||   start.getDate() !== current.getDate())) {
            //   dateErrors = true;
            //   if (this.textleft) {
            //     this.$notify({
            //       type: 'warning',
            //       title: 'Start dates cannot be earlier than the current date !'
            //     });
            //   }
            //   else {
            //     this.$notify({
            //       type: 'warning',
            //       title: '! لا يمكن أن تكون تواريخ البدء أقدم من التاريخ الحالي'
            //     });
            //   }
            //
            // }
            // else if (new Date(this.entities[i].phases[j]['start_date']) > new Date(this.entities[i].phases[j]['end_date'])) {
            //   dateErrors = true;
            //   if (this.textleft) {
            //     this.$notify({
            //       type: 'warning',
            //       title: 'Start dates cannot be later than the end dates !'
            //     });
            //   }
            //   else {
            //     this.$notify({
            //       type: 'warning',
            //       title: '! لا يمكن أن تكون تواريخ البدء بعد تواريخ الانتهاء'
            //     });
            //   }
            //
            // }
            // else if (new Date(this.entities[i].phases[j]['end_date']) < new Date()) {
            //   dateErrors = true;
            //   if (this.textleft) {
            //     this.$notify({
            //       type: 'warning',
            //       title: 'End dates cannot be earlier than the current date !'
            //     });
            //   }
            //   else {
            //     this.$notify({
            //       type: 'warning',
            //       title: '!لا يمكن أن تكون تواريخ الانتهاء أقدم من التاريخ الحالي'
            //     });
            //   }
            //
            // }
          }
        }
        }
        return dateErrors;
      },
      onSubmit() {
        console.log("TITLE : " + this.title);
        console.log("MESSAGE : " + this.message);
        console.log("TEAM MEMBERS : ");
        console.log(this.teammembers);
        console.log("COMMITTEE MEMBERS ");
        console.log(this.committeeMembers);
        console.log("ENTITIES : ");
        console.log(this.entities);



            if (this.title !== '' && this.message !== '' && this.teammembers !== [] && this.committeeMembers !== [] && this.entities !== []) {
                this.localerrors = null;
                let dateErrors = this.checkIfDateErrors();
                // console.log("WE IN HERE");
                // console.log("DATE ERRORS : " + dateErrors);

                if (!dateErrors) {


                  let formData = {'assignment_id' : UserService.getAssignmentId(), 'title':this.title,'description':this.message, 'team_members' : this.teammembers,'committee_members' : this.committeeMembers, 'entities' : this.entities};
                  console.log(formData);
                  Promise.all([
                    store.dispatch(EDIT_ASSIGNMENT, formData),

                  ]).then(() => {
                      this.isLoading = false;
                      if (this.textleft) {
                        this.$notify({
                          type: 'success',
                          title: 'Assignment updated successfully'
                        })
                      }
                      else {
                        this.$notify({
                          type: 'success',
                          title: '! تم تحديث المهام بنجاح'
                        })

                      }

                      this.$router.push({ name: "overview" })
                  });
                }
            }
            else {
              if (this.textleft) {
                this.$notify({
                      type: 'warning',
                      title: 'Please fill in all required fields'
                    })
              }
              else {
                this.$notify({
                      type: 'warning',
                      title: 'يرجى تعبئة جميع الحقول المطلوبة'
                    })
              }

              // this.localerrors = "Email or Password cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },

      onChange(pos1, pos2, startEnd, date) {
        console.log(document.getElementById("startDate").value);
        // this.check(pos1, pos2);

        let startDate = document.getElementById("startDate").value;
        let endDate = document.getElementById("endDate").value;
        console.log("START " + startDate);

        console.log("END " + endDate);
        if (startEnd == 0) {
          // if (Number(startDate.split("-")[0]) < new Date().toISOString().split(" ")[0].split("-")[0] || Number(startDate.split("-")[1]) < new Date().toISOString().split(" ")[0].split("-")[1] || Number(startDate.split("-")[2].split("T")[0]) < new Date().toISOString().split(" ")[0].split("-")[2].split("T")[0]) {
            if (new Date(startDate) < new Date() && !(new Date(startDate).getDate()== new Date().getDate() && new Date(startDate).getMonth() == new Date().getMonth()) ) {
            if (!this.is_initial_modification) {
              if (this.textleft) {
                this.$notify({
                          type: 'warning',
                          title: 'Start date cannot be older than current date !'
                        });
              }
              else {
                this.$notify({
                          type: 'warning',
                          title: '! لا يمكن أن تكون تواريخ البدء أقدم من التاريخ الحالي'
                        });

              }
            }
            // else {
            //   this.is_initial_modification = false;
            // }


          }
        }
        else {
            // if (Number(endDate.split("-")[0]) < new Date().toISOString().split(" ")[0].split("-")[0] || Number(endDate.split("-")[1]) < new Date().toISOString().split(" ")[0].split("-")[1] || Number(endDate.split("-")[2].split("T")[0]) < new Date().toISOString().split(" ")[0].split("-")[2].split("T")[0]) {
          // if (new Date(endDate) < new Date()) {
          //   if (!this.is_initial_modification) {
          //   if (this.textleft) {
          //     this.$notify({
          //         type: 'warning',
          //         title: 'End date cannot be older than current date !'
          //       });
          //   }
          //   else {
          //     this.$notify({
          //       type: 'warning',
          //       title: '!لا يمكن أن تكون تواريخ الانتهاء أقدم من التاريخ الحالي'
          //     });
          //   }
          // }
          // else {
          //   this.is_initial_modification = false;
          // }
          //
          // }
          // if (Number(startDate.split("-")[0]) > Number(endDate.split("-")[0]) || Number(startDate.split("-")[1]) > Number(this.entities[pos1].phases[pos2].end_date.split("-")[1]) || Number(startDate.split("-")[2]) >  Number(endDate.split("-")[2])) {
          console.log("START DATE : " + startDate);
          console.log("END DATE : " + endDate);
          console.log(new Date(startDate) > new Date(endDate));
          console.log(new Date(startDate) < new Date(endDate));
          if (new Date(startDate) > new Date(endDate)) {
            // if (!this.is_initial_modification) {
            if (this.textleft) {
              this.$notify({
                        type: 'warning',
                        title: 'Start date cannot be older than end date !'
                      });
            }
            else {
              this.$notify({
                type: 'warning',
                title: '!لا يمكن أن تكون تواريخ الانتهاء أقدم من التاريخ الحالي'
              });
            }
          // }
          // else {
          //   this.is_initial_modification = false;
          // }


          }

          // if (new Date(startDate) < new Date(endDate)) {
          //   // if (!this.is_initial_modification) {
          //   if (this.textleft) {
          //     this.$notify({
          //               type: 'warning',
          //               title: 'End date cannot be earlier than start date !'
          //             });
          //   }
          //   else {
          //     this.$notify({
          //       type: 'warning',
          //       title: '! لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ البدء'
          //     });
          //   }
          // // }
          // // else {
          // //   this.is_initial_modification = false;
          // // }
          //
          //
          // }
        }
        // console.log("SIH DIHDE");
          // this.timeslot = event.target.value;
          // console.log(pos1,pos2);
      },

      onChangeRType(event, pos1, pos2) {
        console.log(pos1, pos2);
        console.log(event.target.attributes[0].value);
          console.log(event.target.value);
          console.log(event.target.innerText);
          // if (event.target.value === "Internal Audit") {
          //   document.getElementById('reportType').innerHTML = texts.internal_audit;
          // }
          // else {
          //   document.getElementById('reportType').innerHTML = texts.forensic;
          // }
          this.entities[pos1].phases[pos2].findings_type = event.target.attributes[0].value;//event.target.innerText;
          console.log(this.entities[pos1].phases[pos2].findings_type);
          // this.report_type = event.target.innerText;
          console.log(event);
      },
      check(pos1, pos2) {
        // console.log("CHECK START");
        // console.log(Object.values(this.entities)[0].phases[0].start_date);
        //  console.log("START " + this.entities[pos1].phases[pos2].start_date);

        // console.log("END " + this.entities[pos1].phases[pos2].end_date);
        // console.log("CHECK END");
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      },
      archiveAssignmentFunction() {
        this.modals.modal16 = false;
        let formData = {'assignment_id' : UserService.getAssignmentId()};
        console.log(formData);
        Promise.all([
          store.dispatch(ARCHIVE_ASSIGNMENT, formData),

        ]).then((data) => {
          if (Number(data[0]['errFlag']) === 0) {
            this.$router.push({name : "assignments"});
            if (this.textleft) {
              this.$notify({
                "title" : "Assignment successfully archived !",
                "type" : "success"
              });
            }
            else {
              this.$notify({
                "title" : "تم أرشفة المهمة بنجاح",
                "type" : "success"
              });
            }
          }
      });
      },
      archiveAssignment() {
        this.modals.modal16 = true;
      },
      deleteAssignmentFunction() {
        this.modals.modal17 = false;
        let formData = {'assignment_id' : UserService.getAssignmentId()};
        console.log(formData);
        Promise.all([
          store.dispatch(DELETE_ASSIGNMENT, formData),

        ]).then((data) => {
          if (Number(data[0]['errFlag']) === 0) {
            this.$router.push({name : "assignments"});
            if (this.textleft) {
              this.$notify({
                "title" : "Assignment successfully deleted !",
                "type" : "success"
              });
            }
            else {
              this.$notify({
                "title" : "تم حذف المهمة بنجاح",
                "type" : "success"
              });
            }
          }
      });
      },
      deleteAssignment() {
        this.modals.modal17 = true;
      }
  }
  };

</script>
<style></style>
